import * as jsxRuntime from "/Users/joseph/workspaces/monorepo/apps/masala-console/node_modules/react/jsx-runtime.js"
export const jsx = jsxRuntime.jsx
export const jsxs = jsxRuntime.jsxs
export const Fragment = jsxRuntime.Fragment